<script>

const defaultSettings = {
    autoRotate: false,
    time: 500,
    displayedThumbs: 1
}
export default {
    name: "ConstructionPhotoViewer",

    props: {
        settings: {
            default: () => {
            },
            Type: Object
        },
        photos: {
            default: [],
            Type: Array
        }
    },

    data() {
        return {
            key: 0,
            options: Object.assign(defaultSettings, this.settings),
            currentKey: 0,
            ui: {
                inTransaction: false,
                interval: null
            },
            totalPhoto: this.photos.length - 1
        }
    },

    ready() {
        if (this.options.autoRotate) {
            this.ui.interval = setInterval(() => this.nextPhoto(), this.options.time)
        }
    },

    computed: {
        currentPhoto() {
            if (this.photos[this.currentKey] == undefined) {
                return {klarge: "", medium: ""}
            }

            return this.photos[this.currentKey].url
        },

        displableThumbs() {
            let start = this.currentKey - this.options.displayedThumbs
            const take = this.options.displayedThumbs * 2 + 1
            let max = this.totalPhoto - take + 1

            let thumbs = {}

            if (start > max) {
                start = max
            }


            if (start <= 0) {
                start = 0
            }


            for (let i = 0; i < take; i++) {
                let key = [start + i]

                if (this.photos[key] != undefined) {
                    thumbs[key] = this.photos[key]
                }

            }

            return thumbs
        },

        previousImage() {
            if (this.currentKey === 0) {
                return this.totalPhoto
            }

            return this.currentKey - 1
        },
        nextImage() {
            if (this.currentKey === this.totalPhoto) {
                return 0
            }
            return this.currentKey + 1
        }
    },

    methods: {
        toImage(key) {
            this.changePhoto(key)
            this.cancelRotate()
        },
        changePhoto(newKey) {
            this.ui.inTransaction = false
            this.currentKey = newKey
        },
        nextPhoto() {
            return this.changePhoto(this.nextImage)
        },

        previousPhoto() {
            return this.changePhoto(this.previousImage)
        },

        cancelRotate() {
            if (!this.options.autoRotate) {
                return
            }

            this.options.autoRotate = false
            clearInterval(this.ui.interval)
        },

        showGallery() {
            this.$refs.gallery.show(this.photos, this.currentKey)
        }
    }

}
</script>

<template>
        <div>
            <standalone-gallery v-ref:gallery></standalone-gallery>

            <div v-if='photos.length > 0' class="col-xs-12 col-lg-6" id="modal-photo-container">
                <div class="bigImage" :class="{fading: this.ui.inTransaction}">
                    <div class="imageBox">
                        <img :src='currentPhoto' height="300" style="max-width: 100%;max-height: 300px"
                             @click="showGallery()">
                    </div>
                </div>

                <div>
                    <ul>
                        <li v-if="totalPhoto > 0" style="width: 25px;line-height: 80px;margin-left: 10px;border: none;">
                            <a href="#" @click="previousPhoto"><i class="fa fa-chevron-left"
                                                                  style="font-size: 24px;"></i></a></li>
                        <li v-for="(key,photo)  in displableThumbs" :key='key' :value='photo'
                            :class="{active: currentKey == key}">
                            <a href="" @click.prevent="toImage(key)">
                                <img :src="photo.url" width="100" height="75"/>
                            </a>
                        </li>
                        <li v-if="totalPhoto > 0"
                            style="width: 25px;line-height: 80px;margin-left: -10px;border: none;">
                            <a href="#" @click="nextPhoto">
                                <i class="fa fa-chevron-right" style="font-size: 24px;"></i>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div v-else class="col-xs-12 col-lg-6">
                <h4 class="text-center" style="margin-top: 100px;">Nenhuma foto encontrada</h4>
            </div>
        </div>


</template>

<style scoped>
.imageBox {
    width: 535px;
    vertical-align: middle;
    margin: 0 auto;
    background-color: #ccc;
}
</style>


// WEBPACK FOOTER //
// ConstructionPhotoViewer.vue?6ddfc01a